import React, { useState, useEffect } from 'react';

import {
    Container,
    Grid,
    TextField,
    Button,
    InputLabel,
    Select,
    MenuItem
} from '@material-ui/core';
import InputMask from "react-input-mask";
import DateFnsUtils from '@date-io/date-fns';
import { format, addMinutes, parseISO } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';

import Label from '../../../components/Label';

import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

import {
    ContainerBox,
    Content,
    Row,
} from './styles';

const Event = ({
        nextStep,
        onChange,
        onChangeNumber,
        handleDateStartAt,
        handleDateFinishAt,
        values
    }) => {
    const [hours, setHours] = useState([]);

    useEffect(() => {
        var times = [];
        var tt = 0;
        for (var i=0;tt<24*60; i++) {
            var hh = Math.floor(tt/60);
            var mm = (tt%60);
            times[i] = ("0" + (hh % 24)).slice(-2) + ':' + ("0" + mm).slice(-2);
            tt = tt + 30;
        }
        setHours(times)
    }, []);

    return (
        <ContainerBox>
            <Content>
                <Container className="container" maxWidth="md">
                    <Row>
                        <Container className="container" maxWidth="md">
                        <Label
                            size='big'
                            color='dark'
                            align='center'
                            font='Roboto'
                            padding='10px 0 30px'
                        >Cadastro os dados do evento</Label>
                        <Grid container justify="space-around" spacing={2}>
                            <Grid item md={8}>
                                <TextField
                                    key="nome"
                                    name="name"
                                    required
                                    label="Nome do evento"
                                    onChange={onChange}
                                    value={values.name}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item md={4}>
                                <InputMask
                                    mask="+55 (99) 9 9999-9999"
                                    value={values.phone}
                                    onChange={onChange}
                                    disabled={false}
                                    maskChar=""
                                    type="text"
                                    name="phone"
                                >
                                    {() => <TextField
                                        key="phone"
                                        name="phone"
                                        label="Telefone para contato"
                                        required
                                        fullWidth
                                        value={values.phone}
                                        onChange={onChange}
                                    />}
                                </InputMask>
                            </Grid>
                        </Grid>
                        <Grid container justify="space-around" spacing={2}>
                            <Grid item md={8}>
                                <TextField
                                    key="address"
                                    name="address"
                                    required
                                    label="Endereço"
                                    onChange={onChange}
                                    value={values.address}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item md={4}>
                                <InputMask
                                    mask="99999-999"
                                    value={values.cep}
                                    onChange={onChange}
                                    disabled={false}
                                    maskChar=""
                                    type="text"
                                    name="cep"
                                >
                                    {() => <TextField
                                        key="cep"
                                        name="cep"
                                        label="Cep"
                                        required
                                        fullWidth
                                        value={values.cep}
                                        onChange={onChange}
                                    />}
                                </InputMask>
                            </Grid>
                        </Grid>

                        <Grid container justify="space-around" spacing={2}>
                            <Grid item md={6}>
                                <TextField
                                    label="Number"
                                    type="number"
                                    name="count_rows"
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{ inputProps: { min: 0 } }}
                                    value={values.count_rows}
                                    onChange={onChangeNumber}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item md={6}>
                                <TextField
                                    name="count_columns"
                                    label="Colunas"
                                    type="number"
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{ inputProps: { min: 0 } }}
                                    value={values.count_columns}
                                    onChange={onChangeNumber}
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                        <Grid container justify="space-around" spacing={2}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <Grid item md={3} xs={6}>
                                    <KeyboardDatePicker
                                        disableToolbar
                                        variant="inline"
                                        format="yyyy-MM-dd"
                                        margin="normal"
                                        name="start_at"
                                        label="Data de início"
                                        value={values.start_at}
                                        onChange={handleDateStartAt}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                    />
                                </Grid>
                            </MuiPickersUtilsProvider>
                            <Grid item md={2} xs={6}>
                                <Select
                                    name="start_hour"
                                    value={values.start_hour}
                                    onChange={onChange}
                                >
                                    {hours.map(item => (
                                        <MenuItem value={item}>{item}</MenuItem>
                                    ))}
                                </Select>
                            </Grid>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <Grid item md={3} xs={6}>
                                    <KeyboardDatePicker
                                        disableToolbar
                                        variant="inline"
                                        format="yyyy-MM-dd"
                                        margin="normal"
                                        name="finish_at"
                                        label="Data de término"
                                        value={values.finish_at}
                                        onChange={handleDateFinishAt}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                    />
                                </Grid>
                            </MuiPickersUtilsProvider>
                            <Grid item md={2} xs={6}>
                                <Select
                                    label="Horario"
                                    name="finish_hour"
                                    value={values.finish_hour}
                                    onChange={onChange}
                                >
                                    {hours.map(item => (
                                        <MenuItem value={item}>{item}</MenuItem>
                                    ))}
                                </Select>
                            </Grid>
                        </Grid>

                        <Grid container justify="space-around" spacing={2}>
                            <Grid item md={12}>
                                <TextField
                                    key="description"
                                    name="description"
                                    required
                                    multiline
                                    rows={3}
                                    label="Descrição"
                                    onChange={onChange}
                                    value={values.description}
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                        </Container>
                    </Row>
                </Container>
                <div>
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={nextStep}
                    >próximo</Button>
                </div>
            </Content>
        </ContainerBox>
    )
}

export default Event;
